export const css = {
    root: '_2W68876y',
    assess_card: 'JGQkkGmS',
    title: '_1aMszxeO',
    actions: '_11C3pq3m',
    ' _key': 'certwise-theme/certwise/explore-view/nav-card'
};
export default css;
